<template>
  <div>
    <p class="subtitle">
      Select which tier you would like to upgrade or downgrade your product to.
    </p>
    <p class="included">
      <span>Features included in all plans</span>
      <span
        v-popover:features.bottom
        class="question-mark"
      >
        <img :src="Question">
      </span>
    </p>
    <v-popover
      class="popover"
      name="features"
      event="hover"
      :width="300"
    >
      The following features are included in all plans:
      <ul class="popover-feature-list">
        <li
          v-for="(feature, index) in plans[0].deal.features"
          :key="index"
          class="popover-feature"
        >
          {{ feature.feature }}
        </li>
      </ul>
    </v-popover>

    <p class="choose">
      Choose New Plan:
    </p>
    <PlanTier
      :current-plan="currentPlan"
      :plans="plans"
      @select="onSelectPlan"
    />
  </div>
</template>

<script>
import PlanTier from './PlanTier.vue';
import Question from '../../../public/question.svg';

export default {
  name: 'SelectPlan',
  components: {
    PlanTier,
  },
  props: {
    plans: {
      type: Array,
      required: true,
    },
    selectedPlan: {
      type: Object,
      required: true,
    },
    currentPlan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Question,
    };
  },
  methods: {
    onSelectPlan(id, isMobile) {
      if ((isMobile && window.innerWidth < 640) || isMobile !== true) {
        this.$emit('selectPlan', id, isMobile);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../variables.scss";

.included {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
}

.choose {
  display: block;
  font-size: 14px;
  font-weight: 500;

  @media screen and (min-width: 640px) {
    display: none;
  }
}

.subtitle {
  font-size: 14px;
  font-weight: 500;
  margin: 20px 0px 10px;
}

.question-mark {
  display: flex;
  margin-left: 5px;
  img {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}

.popover {
  padding: 15px;
  font-size: 12px;
}

.popover-feature-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.popover-feature {
  font-size: 12px;
  line-height: 12px;
  color: #4F5A68;
  margin: 10px 0px;
  padding-left: 18px;
  background-repeat: no-repeat;
  background-image: url(../../../public/check.svg);
  background-size: 12px;
}

</style>
